import React, { FC } from "react";
import { IconImage } from "../../../kanopy-ui/Icon/Icon";
import CircularButton from "../../../kanopy-ui/CircularIconButton/CircularButton";

const ButtonNotifications: FC = () => {
   return <CircularButton icon={IconImage.MdNotifications} />;
};

export default ButtonNotifications;
